export const resolveLightboxScriptName = (type, { preview = false } = {}) => {
  if (Number(type) === 2) return 'h.js';
  return preview ? 'a-preview.js' : 'a.js';
};

export const buildLightboxInstallScript = (lightbox, apiUrl) => {
  if (!lightbox || !apiUrl) return '';
  const baseUrl = String(apiUrl).replace(/\/+$/, '');
  const scriptName = resolveLightboxScriptName(lightbox.type);
  return `<script class="dwi-components" id="${lightbox.lightboxId}|${lightbox.beaconId}" src="${baseUrl}/scripts/${scriptName}"></script>`;
};
